module.exports = __webpack_public_path__ + "static/media/companySize.db823eec.svg";